/**
 * useOnboarding Hook
 * Access onboarding context from any component
 */

import { useContext } from 'react';
import { OnboardingContext } from '@/contexts/onboarding-context';
import type { OnboardingContextValue } from '@/types/onboarding';

/**
 * Hook to access onboarding context
 * @throws Error if used outside OnboardingProvider
 */
export function useOnboarding(): OnboardingContextValue {
  const context = useContext(OnboardingContext);
  if (context === undefined) {
    throw new Error('useOnboarding must be used within an OnboardingProvider');
  }
  return context;
}
